import s from '../GigAssMessage.module.sass'

import { Text } from '@shared/ui/Typography/Text'
import { Button } from '@shared/ui/Actions/Button'
import { FormEvent, useEffect, useState } from 'react'

const DELAY = 500

/**
 * @function WaitingMessage - компонент сообщения о том, что ассистент думает
 * @param {Function} onCancel - функция, которая будет вызвана при нажатии на кнопку
 * @returns {JSX.Element}
 */
const WaitingMessage = ({ onCancel }: { onCancel: (e: FormEvent) => void }): JSX.Element => {
  const [isVisible, setIsVisible] = useState(false)

  const onCancelHandle = (e: FormEvent) => {
    setIsVisible(false)
    onCancel(e)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true)
    }, DELAY)

    return () => clearTimeout(timeout)
  }, [])

  return (
    <li className={`${s.message} ${s.messageStateConfused} ${isVisible ? s.visible : ''}`} data-type={'bot'}>
      <span className={s.messageWaitingWrapper}>
        <Text
          className={`${s.messageText} ${s.messageTextWaiting}`}
          sizes='M'
          tag='p'
          children='Выбираю лучшее для вас'
        />
        <span className={s.messageWaitingDots}>
          <span className={s.messageWaitingDot1}>.</span>
          <span className={s.messageWaitingDot2}>.</span>
          <span className={s.messageWaitingDot3}>.</span>
        </span>
      </span>

      <Button type='button' onClick={onCancelHandle} className={s.retryButton} sizes='L' mode='ghost' disabled={false}>
        Остановить
      </Button>
    </li>
  )
}

export default WaitingMessage
